<ion-item *ngIf="timings">
  <ion-select
              translocoSelect
              interface="popover"
              [disabled]="!timings?.length && !showAsapOption"
              [value]="value$ | async"
              (ionChange)="onSelectChange($event)">
    <ion-select-option *ngIf="showAsapOption" [value]="0">{{
      'takeout.asap' | transloco
      }}</ion-select-option>
    <ion-select-option *ngFor="let timing of timings" [value]="timing.id">
      {{ timing | posMealDeliveryAreaTimingDisplay: (langChanges$ | async):deliveryType }}
    </ion-select-option>
  </ion-select>
</ion-item>